import { render } from "./AppRegisterView.vue?vue&type=template&id=00987838&scoped=true"
import script from "./AppRegisterView.vue?vue&type=script&lang=js"
export * from "./AppRegisterView.vue?vue&type=script&lang=js"

import "./AppRegisterView.vue?vue&type=style&index=0&id=00987838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00987838"]])

export default __exports__